import { render, staticRenderFns } from "./notification-view.vue?vue&type=template&id=1a755976&scoped=true&"
import script from "./notification-view.vue?vue&type=script&lang=js&"
export * from "./notification-view.vue?vue&type=script&lang=js&"
import style0 from "./notification-view.vue?vue&type=style&index=0&id=1a755976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a755976",
  null
  
)

export default component.exports